import InfoEdil from './info-edil';
export default InfoEdil